<script>
	import Vue from 'vue'
    import QS from 'qs'
	const LOGINMSG = "此功能需要登录，单击【确定】开始登录"	
	const BASE_URL_T3 = "https://t3.lenovoimage.com"
	const BASE_URL_T3_LOCAL = "https://localhost:60195"
	const BASE_RUL_ABC ="https://abcapi.lenovoimage.com"
	const BASE_RUL_ABC_DEV ="https://abcapi_dev.lenovoimage.com"	
    const devicesList = []
    const currentModel = ''
     const currentSN = ''

	// 定义一些公共的属性和方法	
	function commonFun() {
		console.log("公共方法")
    }
	function applog(moudel){
        console.log('app date collection')
        let that = this		  			
        var data = QS.stringify({
                requestsource:'公众号',
                customerid:'',
                moudel:moudel
            });	
            var postUrl = this.BASE_URL_T3 + '/api/pdsm/logforsvchome';			  
            var config = {
            method: 'post',
            url: postUrl,				
            headers: { 
                'Authorization': '', 
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data : data
            };	 		  	  
            Vue.axios(config)
            .then(function (response) {
            })
            .catch(function (error) {
            console.log(error);
            });
	}
	
	// 暴露出这些属性和方法
	export default {
		commonFun,
		applog,
		LOGINMSG,
		BASE_URL_T3,
		BASE_RUL_ABC,
		BASE_RUL_ABC_DEV,
		BASE_URL_T3_LOCAL,
        devicesList,
        currentModel,
        currentSN
	}
</script>
